import {
    FETCH_GARANTIAS,
    LOADING_GARANTIAS,
} from './types';

import {
    fetchGarantiasApi,
} from '../api/axios';

export const fetchGarantias = (params) => async dispatch => {

    dispatch({
        type: LOADING_GARANTIAS,
        payload: true
    });

    const req = fetchGarantiasApi(params);

    req.then((garantias) => {

        dispatch({
            type: FETCH_GARANTIAS,
            payload: garantias
        });

        dispatch({
            type: LOADING_GARANTIAS,
            payload: false
        });

    })
}
